import classNames from 'classnames';

import { HeroHeadline } from '@components/HeroHeadline';

import { CmsProductShowcase } from '@interfaces/common';
import { breakpoints } from '@utils/device';

import styles from './ProductShowcase.module.css';
import { ProductShowcaseItem } from './ProductShowcaseItem';

export type ProductShowcaseProps = Omit<CmsProductShowcase, '_type' | '_key'>;

export const ProductShowcase: React.VFC<ProductShowcaseProps> = ({
	headline,
	showcaseGrid,
}) => {
	return (
		<section>
			<HeroHeadline headingLevel={2} {...headline} />
			<ul className={classNames(styles.grid, 'grid')}>
				{showcaseGrid.map(({ _key, description, image, sellSheet, title }) => (
					<li key={_key}>
						<ProductShowcaseItem
							description={description}
							image={image}
							imageSizes={`${breakpoints.md} 50vw, ${breakpoints.lg} 33vw, 100vw`}
							linkText="Download sell sheet"
							title={title}
							url={sellSheet}
						/>
					</li>
				))}
			</ul>
		</section>
	);
};
